// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/index.scss
// module id = 589
// module chunks = 0